import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Full-page tier-gate prompt. Shown when a feature requires a higher
 * subscription tier (currently used by OnBehalfOrder and TeamManagement).
 *
 * Props are pre-translated strings — callers own their translation namespace.
 */
const UpgradePromptCard = ({ badge, title, body, ctaLabel, backLabel }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-purple-50">
      <Navbar />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gradient-to-br from-purple-600 to-violet-600 rounded-2xl p-1 shadow-lg">
          <div className="bg-white rounded-[14px] p-8 text-center">
            <div className="w-14 h-14 bg-gradient-to-br from-purple-100 to-violet-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Sparkles className="w-7 h-7 text-purple-600" />
            </div>
            {badge && (
              <span className="inline-block px-3 py-1 bg-purple-50 text-purple-700 text-xs font-semibold rounded-full mb-3 uppercase tracking-wide">
                {badge}
              </span>
            )}
            <h1 className="text-2xl font-bold text-gray-900 mb-3">{title}</h1>
            <p className="text-sm text-gray-600 mb-6 max-w-md mx-auto">{body}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => navigate('/wholesaler/pricing')}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm font-semibold shadow-sm"
              >
                <Sparkles className="w-4 h-4" />
                {ctaLabel}
              </button>
              <button
                onClick={() => navigate('/wholesaler/dashboard')}
                className="inline-flex items-center gap-2 px-4 py-2.5 text-gray-600 hover:text-gray-900 text-sm font-medium"
              >
                {backLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UpgradePromptCard;
